import {
  LayoutDashboard,
  Shield,
  AlertTriangle,
  FileText,
  TrendingUp,
  Droplets,
  PieChart,
  FileSpreadsheet,
  Users,
  PoundSterling,
} from 'lucide-react';
import type { NavigationSection } from '../types/entities';

export const NAVIGATION_CONFIG: NavigationSection[] = [
  {
    id: 'executive-core',
    label: 'Executive Core',
    items: [
      {
        id: 'overview',
        label: 'Overview',
        path: '/cfo/overview',
        icon: LayoutDashboard,
      },
      {
        id: 'arbiter-challenges',
        label: 'Arbiter and Challenges',
        path: '/cfo/arbiter-challenges',
        icon: Shield,
      },
      {
        id: 'actions-escalations',
        label: 'Actions and Escalations',
        path: '/cfo/actions-escalations',
        icon: AlertTriangle,
      },
      {
        id: 'committee-pack',
        label: 'Committee Pack',
        path: '/cfo/committee-pack',
        icon: FileText,
      },
    ],
  },
  {
    id: 'financial-domains',
    label: 'Financial Domains',
    items: [
      {
        id: 'financial-planning',
        label: 'Financial Planning',
        path: '/cfo/financial-planning',
        icon: TrendingUp,
      },
      {
        id: 'treasury-liquidity',
        label: 'Treasury & Liquidity',
        path: '/cfo/treasury-liquidity',
        icon: Droplets,
      },
      {
        id: 'capital-management',
        label: 'Capital Management',
        path: '/cfo/capital-management',
        icon: PieChart,
      },
      {
        id: 'financial-reporting',
        label: 'Financial Reporting',
        path: '/cfo/financial-reporting',
        icon: FileSpreadsheet,
      },
      {
        id: 'investor-relations',
        label: 'Investor Relations',
        path: '/cfo/investor-relations',
        icon: Users,
      },
      {
        id: 'cost-management',
        label: 'Cost Management',
        path: '/cfo/cost-management',
        icon: PoundSterling,
      },
    ],
  },
];
